import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class FormatCapitalizedConstantsService {
    constructor() {}

    formatConstantToNormalText(value: string): string {
        return value
            .toLowerCase()
            .split('_')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    }
}